export enum PagesType {

   REQUEST_ABOUT_US_CONTENT = "REQUEST_ABOUT_US_CONTENT",
   SET_ABOUT_US_CONTENT = "SET_ABOUT_US_CONTENT",

   REQUEST_PACKAGE_GUIDE_CONTENT = "REQUEST_PACKAGE_GUIDE_CONTENT",
   SET_PACKAGE_GUIDE_CONTENT = "SET_PACKAGE_GUIDE_CONTENT",

   REQUEST_APP_LINKS_CONTENT = "REQUEST_APP_LINKS_CONTENT",
   SET_APP_LINKS_CONTENT = "SET_APP_LINKS_CONTENT",

}